export const allconfig = {
    env: process.env.REACT_APP_ENV || 'dev',
    dev_api_url : process.env.REACT_APP_DEV_API_URL || 'http://localhost:9000',
    dev_site_url: process.env.REACT_APP_DEV_SITE_URL || 'http://localhost:3000',
    prod_api_url : process.env.REACT_APP_PROD_API_URL || 'https://cryptolits-admin.herokuapp.com',
    prod_site_url: process.env.REACT_APP_PROD_SITE_URL || 'http://dashboard-xyz.cryptolits.org',
    prod_landing_url: process.env.REACT_APP_PROD_LANDING_URL || 'http://cryptolits.com',
}